import { render } from "./SelectButton.vue?vue&type=template&id=8a3a712e"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"

import "./SelectButton.vue?vue&type=style&index=0&id=8a3a712e&lang=scss"
/* custom blocks */
import block0 from "./SelectButton.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__